import { Box } from '@hivebrite/design-system/Box';
import { SimpleCard } from '@hivebrite/design-system/SimpleCard';

import TopicMemberRequestContainer from 'hb-react/shared/apps/Topics/containers/TopicMemberRequestContainer';

const JoinCard = () => (
  <Box display="block" maxWidth="655px" margin="auto">
    <SimpleCard
      faIconProps={{
        iconName: 'lock-keyhole',
      }}
      title={s__('JoinCard|This group is private')}
      description={s__('JoinCard|Join to see more content')}
      buttonComponent={TopicMemberRequestContainer}
    />
  </Box>
);

export default JoinCard;
